import type { GlobalState } from 'little-state-machine';

export const initialState: GlobalState = {
  chatHistory: [],
  enrichmentFrom: undefined,
};
